export default __webpack_public_path__ + "static/media/game-phone-642x727.de3a7717.png";